import React from 'react'
import { SVGProps } from './types'

export const NavCatalog: React.FC<SVGProps> = ({
  size = 24,
  color = 'currentColor',
  onClick,
  strokeWidth = 2,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      onClick={onClick && (() => onClick())}
    >
      <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" fill="none" />
      <rect x="2" y="4" width="20" height="16" rx="2" fill="none" />
    </svg>
  )
}
